import { MediaObjectType } from 'interfaces/mediaObject.types';
import { API_ROOT } from 'services/api';

export const getMediaObjectURI = (
  partialUri: string | number | MediaObjectType | undefined,
): string => {
  if (!partialUri) {
    console.warn('No parameter received for getMediaObjectURI'); // eslint-disable-line no-console
    return '';
  }
  // eslint-disable-next-line no-restricted-globals
  if (typeof partialUri === 'number' || !isNaN(Number(partialUri))) {
    return `${API_ROOT}/v2/media-objects/${partialUri}`;
  }
  if (typeof partialUri === 'string') {
    if (partialUri.indexOf('/v2/media-objects/') === 0) {
      return `${API_ROOT}${partialUri}`;
    }
    return `${API_ROOT}/v2/media-objects/${partialUri}`;
  }
  if (partialUri['@id']) {
    return `${API_ROOT}${partialUri['@id']}`;
  }
  if (partialUri.id) {
    return `${API_ROOT}/v2/media-objects/${partialUri.id}`;
  }

  // eslint-disable-next-line no-console
  console.error(
    'The received parameter for getMediaObjectURI does not have the expected format:',
    `"${partialUri}"`,
    'Expected either a string or a number or a MediaObjectType',
  );
  return '';
};

export const getTypeFromExtension = (extension: string | undefined): string => {
  if (!extension) {
    return 'noFile';
  }
  switch (extension) {
    case 'JPG':
    case 'JPEG':
    case 'PNG':
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return 'image';
    case 'pdf':
    case 'xls':
    case 'xlsx':
      return 'application';
    case 'mpeg':
    case 'mp4':
    case 'mov':
      return 'video';
    default:
      return 'other';
  }
};

export const getExtension = (
  fileName: string | undefined,
): string | undefined => {
  if (fileName) {
    const splitFileName = fileName.split('.');
    if (splitFileName.length !== 1) {
      return splitFileName[splitFileName.length - 1];
    }
  }
  return undefined;
};
